import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from 'authConfig'
import { useCallback } from 'react'

type GetTokenOptions = {
  onInteractionRequired?: () => void
}

export const useGetToken = () => {
  const { instance } = useMsal()
  const getToken = useCallback(
    async (options?: GetTokenOptions) => {
      const currentAccount = instance.getActiveAccount()
      if (!currentAccount) {
        return undefined
      }

      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: currentAccount,
        })
        sessionStorage.setItem('vfuToken', response.accessToken)
        return response.accessToken
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          options?.onInteractionRequired?.()
          return undefined
        }
        console.error(error)
        return undefined
      }
    },
    [instance]
  )

  return getToken
}
